export default __webpack_public_path__ + "static/media/logo.110f8e97.svg";